import {
    Log, LogLevel,
} from 'one-log';

import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';
import platformClient from 'purecloud-platform-client-v2/dist/web-cjs/bundle'
import { Disposition } from 'one-model-local';

// Guard to ensure initializeApplication only runs once per page load
let hasInitialized = false;

// set up the logger
const log = new Log("ccw-app",[
    new BrowserLogger(),
],LogLevel.DEBUG);

/**
 * Main application entry point using the one-web-loader
 * Loads settings from settings.json and initializes the Genesys integration
 * 
 * IMPROVEMENT: Consider using async/await syntax consistently instead of 
 * mixing Promise constructor with async/await
 */
loader({
    log,
    url: 'settings.json',
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
        } = options;

                /**
         * check for the log level config from settings and set default
         */
        //const {logconfig,alertnotify} = settings;
        /**
         * Extract the settings from the options object
         * @param settings - The settings object
         * @param resolver - The resolver object
         * - logconfig: The logging configuration object
         * - alertnotify: The alert notification configuration object
         * - genesys_config: The Genesys configuration object
         * - debug: Debug flag from the genesys_config object
         */
        const { logconfig, alertnotify, genesys_config } = settings;
        const { debug } = genesys_config;
        console.log("[OSF] - debug",debug); 
        //logToConsole("debug", debug);


         /**
         * Conditional debug logging utility
         * Only logs when debug mode is enabled in genesys_config
         * 
         * IMPROVEMENT: Consider using the existing 'log' instance with conditional
         * log levels instead of separate console.log calls for better consistency
         * 
         * @param message - Log message prefix
         * @param data - Optional data to log
         */
         function logToConsole(message: string, data?: any) {
            
            
            if (debug) {
                console.log("[OSF] - ccw-app-genesys", message, data);
            }
        }


        /**
         * check for the log level config from settings and set default
         */
     
        if(logconfig?.level==="INFO"){
            log.setlevel(LogLevel.INFO);
        } else  if(logconfig?.level==="WARN"){
            log.setlevel(LogLevel.WARN);
        } else  if(logconfig?.level==="ERROR"){
            log.setlevel(LogLevel.ERROR);
        } else{
            log.setlevel(LogLevel.DEBUG);
        }
        log.debug(
            'ccw-app-web',
            'app settings', {
            settings,
        });

          // logged in agent id
          const agentId = '761012';
          // adding ani
          const ani = '';
          let alertnotification = new AlertNotification(false,alertnotify?.url,{
                             });
          if(alertnotify?.enable){
            alertnotification = new AlertNotification(true,alertnotify?.url,{
              customer_name:alertnotify?.customer,
              server_id:alertnotify?.servername,
              app_type:"web"
          })
          }
            // enable user specific trace
            enableTrace(agentId, {
                log,
                settings,
            });

        // initialize the app
        const {
            store,
        } = await init('app', {
            log,
            agentId,
            ani,
            settings,
            resolver,
            alertnotification,
            server: new HAServer(
                settings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
            serverone: new HAServerOne(
                settings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
        });
        /*
 * NOTE: This sample use ES6
 */

//const clientId = 'bd17d883-0b40-4725-ba70-a40cdf7fb1c0';
//const clientId = 'bd17d883-0b40-4725-ba70-a40cdf7fb1c0';
        logToConsole(" genesys_config.client_id",  genesys_config.client_id);
        const clientId = genesys_config.client_id || "bd17d883-0b40-4725-ba70-a40cdf7fb1c0";
        logToConsole("clientId", clientId);
        const redirectUri = window.location.protocol + "//" + window.location.hostname + window.location.pathname + "index.html";
        logToConsole("redirectUri", redirectUri);
// PureCloud Platform API
const client = platformClient.ApiClient.instance;
logToConsole("client", client);
client.setPersistSettings(true, 'InteractionWidgetProxy');
// Manually set auth token or use loginImplicitGrant(...) or loginClientCredentialsGrant(...)
// AS-12481: Commented out to prevent manual token setting and use implicit grant instead 
//platformClient.ApiClient.instance.setAccessToken(clientId);
// Specific Platform API Instances
const usersApi = new platformClient.UsersApi();
const notificationsApi = new platformClient.NotificationsApi();
const conversationsApi = new platformClient.ConversationsApi();
var lifecycleStatusMessageTitle = 'Interaction Widget Proxy';
var lifecycleStatusMessageId = 'lifecycle-statusMsg';
var me = null;

// Parse the query parameters to get the pcEnvironment variable so we can setup
// the API client against the proper Genesys Cloud region.
//
// Note: Genesys Cloud will send us pcEnvironment, pcLangTag, and pcConversationId
//       when the iframe is first initialized.  However, we'll come through this code
//       again after the implicit grant redirect, and those parameters won't be there
//       So we have to check if we were able to parse out the environment or not.
var integrationQueryString = "";
if ( window.location.search.length !== 0 ) {
    integrationQueryString = window.location.search.substring(1);
} else if ( window.location.hash.length !== 0 ) {
    integrationQueryString = window.location.hash.substring(1);
}
var appParams = parseAppParameters(integrationQueryString);
sessionStorage.setItem("genesys_uid",appParams.pcConversationId)
//console.log("Initializing platform client for region: " + appParams.pcEnvironment);
logToConsole("Initializing platform client for region", appParams.pcEnvironment);
client.setEnvironment(appParams.pcEnvironment);

// Create instance of Client App SDK
let myClientApp = new window.purecloud.apps.ClientApp({
    pcEnvironment: appParams.pcEnvironment
});

// Log the PureCloud environment (i.e. AWS Region)
//console.log("PureCloud API Client Environment: " + client.environment);
logToConsole("PureCloud API Client Environment", client.environment);
// logToConsole("PureCloud ClientApp Environment: " + myClientApp.pcEnvironment);
logToConsole("PureCloud ClientApp Environment", myClientApp.pcEnvironment);
//console.log("PureCloud ClientApp Version: " + window.purecloud.apps.ClientApp.version);
logToConsole("PureCloud ClientApp Version", window.purecloud.apps.ClientApp.version);
//console.log("PureCloud ClientApp About: " + window.purecloud.apps.ClientApp.about());
logToConsole("PureCloud ClientApp About", window.purecloud.apps.ClientApp.about());



// document.querySelector("#pcConversationId").innerHTML = appParams.pcConversationId;
// document.querySelector("#pcEnvironment").innerHTML = appParams.pcEnvironment;
// document.querySelector("#pcLangTag").innerHTML = appParams.pcLangTag;

//if ( window.location.hash.length !== 0 ) {
    // Call the function to initialize the main Genesys Cloud app logic
    initializeApplication();

    // Log that we've called initializeApplication() for debugging/auditing
    logToConsole("initializeApplication", true);
//}
//
// Bootstrap Listener
//


/**
 * Registers a listener for the Client App SDK's "bootstrap" lifecycle event.
 * This event is triggered when the app is first started or reloaded.
 * The callback logs the event both via the conditional console logger and 
 * the central lifecycle event logger for auditing/debug purposes.
 *
 * If initialization logic for the app should be invoked on every bootstrap,
 * you can uncomment the call to initializeApplication().
 */
myClientApp.lifecycle.addBootstrapListener(() => {
    logToConsole("App Lifecycle Event: bootstrap", true);
    logLifecycleEvent('App Lifecycle Event: bootstrap', true);
    //initializeApplication(); // AS-12481: Commented out to prevent double initialization
});

//
// Focus Listener
//
/**
 * Registers a listener for the Client App SDK's "focus" lifecycle event.
 * This event is triggered when the app gains focus in the Genesys Cloud UI.
 * The callback logs the event both via the conditional console logger and 
 * the central lifecycle event logger for auditing/debug purposes.
 *
 * The callback also shows a toast notification to confirm focus state.
 */
function onAppFocus () {
    logLifecycleEvent('App Lifecycle Event: focus', true);

    myClientApp.alerting.showToastPopup(
        lifecycleStatusMessageTitle,
        'App Focused', {
            id: lifecycleStatusMessageId
        }
    );
}
myClientApp.lifecycle.addFocusListener(onAppFocus);

//
// Blur Listener
//
/**
 * Registers a listener for the Client App SDK's "blur" lifecycle event.
 * This event is triggered when the app loses focus in the Genesys Cloud UI.
 * The callback logs the event both via the conditional console logger and 
 * the central lifecycle event logger for auditing/debug purposes.
 *
 * The callback also shows a toast notification to confirm blur state.
 */
function onAppBlur () {
    logLifecycleEvent('App Lifecycle Event: blur', true);

    myClientApp.alerting.showToastPopup(
        lifecycleStatusMessageTitle,
        'App Blurred', {
            id: lifecycleStatusMessageId
        }
    );
}
myClientApp.lifecycle.addBlurListener(onAppBlur);

//
// Stop Listener
//
/**
 * Registers a listener for the Client App SDK's "stop" lifecycle event.
 * This event is triggered when the app is stopped or closed in Genesys Cloud.
 * The callback logs the event both via the conditional console logger and 
 * the central lifecycle event logger for auditing/debug purposes.
 *
 * The callback also shows a toast notification to confirm stop state.
 */
myClientApp.lifecycle.addStopListener(() => {
    logLifecycleEvent('App Lifecycle Event: stop', true);

    // Clean up other, persistent listeners
    myClientApp.lifecycle.removeFocusListener(onAppFocus);
    myClientApp.lifecycle.removeBlurListener(onAppBlur);

    myClientApp.lifecycle.stopped();

    myClientApp.alerting.showToastPopup(
        lifecycleStatusMessageTitle,
        'App Stopped', {
            id: lifecycleStatusMessageId,
            type: 'error',
            showCloseButton: true
        }
    );

    // Log that we've notified Genesys Cloud of successful app stop
    logLifecycleEvent('Notified Genesys Cloud of Successful App Stop', false);
});

/**
 * Logs lifecycle events to the console and dispatches Redux actions for Genesys interaction data.
 * This function is used to log lifecycle events and dispatch Redux actions for Genesys interaction data.
 * @param logText - The text to log
 * @param incommingEvent - The incoming event
 * @param isBootstrap - Whether the event is a bootstrap event
 * @param flowdata - The flow data
 */
function logLifecycleEvent(logText:any, incommingEvent:any, isBootstrap?:any,flowdata?:any) {

    //console.log(logText)
    logToConsole("logText", logText);
    //console.log("Bootstrap",isBootstrap)
    logToConsole("Bootstrap", isBootstrap);
    // If the event is a bootstrap event, dispatch the Genesys interaction data to the Redux store
    if(isBootstrap) {
        // Dispatch the Genesys interaction data to the Redux store
        if(flowdata) {
            store.dispatch({
                type:"one-state-genesysinteraction/set",
                payload: {
                    flowdata
                }
            })
        }
        // If the flow data has participants, extract the caller ANI/DNIS
        if(flowdata?.participants?.[0]) {
            let callerani:any = "",callerdnis:any = "";
            /*
            if(flowdata.participants[0]?.ani?.length === 16) {
                callerani = flowdata.participants[0].ani.slice(6);
            }
            */
            let participant = flowdata.participants[0];
            if (participant?.ani && participant.ani.length >= 10) {
                callerani = participant.ani.slice(-10); // last 10 digits
            }
            if(flowdata.participants[0]?.dnis?.length === 16) {
                callerdnis = flowdata.participants[0].dnis.slice(6);
            }
            //console.log("----------ANI",callerani,callerdnis)
            logToConsole("----------ANI", { callerani, callerdnis });


            // If the conversation ID is present, dispatch the Genesys interaction data to the Redux store
           if( appParams.pcConversationId) {
            store.dispatch({
                type: "one-state-choosecaller/set",
                payload: {
                    number: callerani,
                    dnis: callerdnis,
                    visible: true,
                    start: true
                }
            });
            //Dispatch GetSession
            store.dispatch({
                type: "one-state-getsession/fetch",
                payload: {
                    sessionKey:appParams.pcConversationId
                }
            });
            let username = sessionStorage.getItem("agentName");
            //Dispostion for Incoming call
            let disp: Disposition = { value: "193" }
            disp.dial_list_uid = appParams.pcConversationId;
            disp.meta00 = agentId;
            disp.meta01 = username;
            disp.meta02 = callerani;
            disp.meta03 = callerdnis;
            disp.meta04 = appParams.pcConversationId;
            disp.meta05 = "Incoming Call";
            store.dispatch({
                type: "store-disposition-code",
                payload: disp
            });
            store.dispatch({
                type: "set-disposition",
                payload: {
                    incomingcall: true
                }
            });
           }
        }

    }
};

// Handler for every Websocket message
/**
 * Handles every Websocket message received from Genesys Cloud.
 * This function is used to handle every Websocket message received from Genesys Cloud.
 * @param event - The event object
 */
function onSocketMessage(event:any){
    //console.log("WebSocket Event Received: " + event.data);
    logToConsole("WebSocket Event Received", event.data);
    let data = JSON.parse(event.data);
    let topic = data.topicName;
    let eventBody = data.eventBody;

    if ( eventBody.id === appParams.pcConversationId ) {
        console.log("Received an event for a Conversation ID that is recognized");
        //document.querySelector("#conversationEvent").innerHTML = JSON.stringify(eventBody, null, 3);
    }
};

/**
 * Initializes the application.
 * This function is used to initialize the application.
 */
function initializeApplication() {
    // If the application has already been initialized, return
    logToConsole("hasInitialized", hasInitialized);
    if (hasInitialized) {
        logToConsole("initializeApplication called more than once, ignoring.");
        return;
    }
    hasInitialized = true;
    //console.log("Performing application bootstrapping");
    logToConsole("Performing application bootstrapping");

    // Perform Implicit Grant Authentication
    //
    // Note: Pass the query string parameters in the 'state' parameter so that they are returned
    //       to us after the implicit grant redirect.
    // Perform Implicit Grant Authentication
    /**
     * Performs Implicit Grant Authentication.
     * This function is used to perform Implicit Grant Authentication.
     * @param clientId - The client ID
     * @param redirectUri - The redirect URI
     * @param state - The state
     */
    client.loginImplicitGrant(clientId, redirectUri, { state: integrationQueryString })
        .then((data:any) => {
            // User Authenticated
            //console.log("User Authenticated: " + JSON.stringify(data));
            logToConsole("User Authenticated", { data: JSON.stringify(data) });

            // Make request to GET /api/v2/users/me?expand=presence
            return usersApi.getUsersMe({ 'expand': ["presence","authorization"] });
        })
        .then((userMe:any) => {
            // Me Response
            me = userMe;
            //console.log("User Agent",me)
            logToConsole("User Agent", me);
            sessionStorage.setItem("agentName", userMe.username);
            sessionStorage.setItem("name", userMe.name);
            store.dispatch({
                type:"one-state-genesysagent/set",
                payload: userMe.username
            })

            //console.log("Getting initial conversation details for conversation ID: " + appParams.pcConversationId);
            logToConsole("Getting initial conversation details for conversation ID", appParams.pcConversationId);
            return conversationsApi.getConversation(appParams.pcConversationId);
        }).then((data:any) => {
            //console.log("Conversation details for " + appParams.pcConversationId + ": " + JSON.stringify(data));
            logToConsole("Conversation details for", { conversationId: appParams.pcConversationId, data: JSON.stringify(data) });
            //document.querySelector("#conversationEvent").innerHTML = JSON.stringify(data, null, 3);
            /*
            const queueName = data?.queue?.name || "";
            const queueId = data?.queue?.id || "";
            console.log("[OSF][ccw-app-genesys index.tsx]queueName,::queueId",queueName,queueId);
            sessionStorage.setItem("genesys_queueName",queueName)
            sessionStorage.setItem("genesys_queueId",queueId)
            */
            myClientApp.lifecycle.bootstrapped();
            /*
            myClientApp.alerting.showToastPopup(
                lifecycleStatusMessageTitle,
                'Bootstrap Complete', {
                    id: lifecycleStatusMessageId,
                    type: 'success'
                }
            );
            */
            let flowdata:any = data
           // console.log("JSON DATA------",data)
            logToConsole("JSON DATA", data);
            // Look to see if a proxy.URL attribute exists in the customer participant data
            // If so redirect to that URL
            let participantsQueueName = undefined;
            let participantsQueueId = undefined;
            let customerQueueName = undefined;
            let customerQueueId = undefined;
            if (Array.isArray(data.participants)) {
            const withQueue = data.participants.find((p: any) => p.queueName || p.queueId);
                participantsQueueName = withQueue?.queueName;
                participantsQueueId = withQueue?.queueId ;
            }
            //console.log("[OSF]participantsQueueName:", participantsQueueName);
            logToConsole("participantsQueueName", participantsQueueName);
            //console.log("[OSF]participantsQueueName:", participantsQueueName); 
            logToConsole("participantsQueueName", participantsQueueName);
            var customer = data.participants.find((participant:any) => participant.purpose === "customer")
           // console.log("[OSF][customer]",customer);
           logToConsole("customer", customer);
            customerQueueName = customer?.queueName || "";
            customerQueueId = customer?.queueId || "";
            //console.log("[OSF][customer][customerQueueName],[customerQueueId]",customerQueueName,customerQueueId)
            logToConsole("customerQueueName", customerQueueName);
            logToConsole("customerQueueId", customerQueueId);
            const queueName = participantsQueueName?participantsQueueName:customerQueueName;
            const queueId = participantsQueueId?participantsQueueId:customerQueueId;
            //console.log("[OSF][ccw-app-genesys index.tsx]queueName,::queueId",queueName,queueId);
            logToConsole("queueName", { queueName, queueId });
            
            sessionStorage.setItem("genesys_queueName",queueName)
            sessionStorage.setItem("genesys_queueId",queueId)
            if ( customer !== undefined ) {
                var proxyUrl = customer.attributes["proxy.URL"];
                if ( proxyUrl !== undefined ) {
                    window.location.href = proxyUrl;
                }
            }

            logLifecycleEvent('Notified Genesys Cloud of Successful App Bootstrap', false,true,flowdata);
        }).catch((err:any) => {
            // Handle failure response
            //console.log("[OSF] initializeApplication ccw-app-genesys console.log err", err);
            logToConsole("initializeApplication ccw-app-genesys error", err);
            console.error("[OSF] initializeApplication ccw-app-genesys err", err);
        });
}

function parseAppParameters(queryString:any) {
    //console.log("Interaction Widget Proxy Query String: " + queryString);
    logToConsole("Interaction Widget Proxy Query String", queryString);

    let appParams:any = {
        pcEnvironment: null,
        pcLangTag: null,
        pcConversationId: null
    };


    if ( queryString.length != 0 ) {
        const pairs = queryString.split('&');

        for (var i = 0; i < pairs.length; i++)
        {
            var currParam = pairs[i].split('=');

            if (currParam[0] === 'pcLangTag') {
                appParams.pcLangTag = currParam[1];
            } else if (currParam[0] === 'pcEnvironment') {
                appParams.pcEnvironment = currParam[1];
            } else if (currParam[0] === 'pcConversationId') {
                appParams.pcConversationId = currParam[1];
            } else if (currParam[0] === 'state') {
                //console.log("Found 'state' query parameter from implicit grant redirect");
                logToConsole("Found 'state' query parameter from implicit grant redirect", true);
                var stateValue = currParam[1];
                //console.log("state = " + stateValue);   
                logToConsole("state", stateValue);   
                var stateValueDecoded = decodeURIComponent(stateValue);
                //console.log("decoded state = " + stateValueDecoded);
                logToConsole("decoded state", stateValueDecoded);
                appParams = parseAppParameters(decodeURIComponent(stateValueDecoded));
            }
        }
    }

    return appParams;
};

        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-web',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });
    })
));
